import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { COLUMNS_SPECIAL_CONVERTER_TOKEN, ColumnsSpecialConverter } from './columns-special.component.converter'
import {
  COLUMNS_SPECIAL_ITEM_CONVERTER_TOKEN, ColumnsSpecialItemConverter
} from './columns-special-item/columns-special-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        columnsSpecialFeature: {
          module: () => import('./columns-special.module').then((m) => m.ColumnsSpecialModule),
          cmsComponents: ['columns_special'],
        },
      }
    }),
    {
      provide: COLUMNS_SPECIAL_CONVERTER_TOKEN,
      useExisting: ColumnsSpecialConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        columns_special: COLUMNS_SPECIAL_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLUMNS_SPECIAL_ITEM_CONVERTER_TOKEN,
      useExisting: ColumnsSpecialItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        columns_special_item: COLUMNS_SPECIAL_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class ColumnsSpecialFeatureModule {}
